import { getCurrentHub } from '@sentry/browser';
import { Hub } from '@sentry/types';
import {
  ExceptionsService,
  User,
  Options,
  Breadcrumb,
  Context,
  ClientOptions,
} from './ExceptionsService';

export class MockSentryExceptionsService implements ExceptionsService {
  static from(clientOptions: ClientOptions): ExceptionsService {
    console.log(`ExceptionsService.init`, clientOptions);

    return new MockSentryExceptionsService();
  }

  get hub(): Hub {
    return getCurrentHub();
  }

  setUser(user: User): void {
    console.log(`ExceptionsService.setUser`, user);
  }

  setContext(options: Context): void {
    console.log('ExceptionsService.setContext', options);
  }

  captureException(error: Error | string, options?: Options) {
    console.error('ExceptionsService.captureException', error, options);
  }

  captureMessage(message: string, options?: Options) {
    console.error('ExceptionsService.captureMessage', message, options);
  }

  addBreadcrumb(breadcrumb: Breadcrumb) {
    console.log('ExceptionsService.addBreadcrumb', breadcrumb);
  }
}
